

const LOGO_DIR = "/homepage/logos";

const LOGO_FILES = [
  "Frame 1430104680.svg",
  "Frame 1430104681.svg",
  "Frame 1430104682.svg",
  "Frame 1430104685.svg",
  "Frame 1430104688.svg",
  "Frame 1430104692.svg",
  "cred.png",
  "Frame 1430104697.svg",
] as const;

function logoSrc(filename: string) {
  return `${LOGO_DIR}/${encodeURIComponent(filename)}`;
}

function scrollToResourceCta(): void {
  document.getElementById("resource-cta")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
}
export default function BusinessHero() {
  return (
    <section
      id="all-resources-hero"
      className="w-full bg-black font-fira text-white py-8 md:py-10"
    >
      {/* Frame: full width mobile, 98% desktop; 1px gradient border */}
      <div className="mx-auto w-[90%] md:w-[98%]">
        <div className="rounded-b-2xl rounded-t-none p-px md:rounded-b-3xl">
          <div className="relative min-h-[min(65dvh,30rem)] overflow-hidden rounded-3xl  md:min-h-[min(65dvh,40rem)] md:rounded-b-3xl border border-[#FFFFFF29]">
            {/* Background image */}
            <img
              src="/business/b2bd.webp"
              alt=""
              className="pointer-events-none absolute inset-0 h-full w-full object-cover object-center md:block hidden"
              loading="eager"
              decoding="async"
              fetchPriority="high"
            />
            <img
              src="/business/b2bm.webp"
              className="pointer-events-none absolute inset-0 h-full w-full object-cover object-center block md:hidden "
              loading="eager"
              decoding="async"
              fetchPriority="high"
            />

            {/* Dark overlay on the left so text is readable */}
            <div className="pointer-events-none absolute inset-0" />

            {/* Content */}
            <div className="relative z-10 flex min-h-[min(65dvh,36rem)] flex-col px-8 py-12 md:min-h-[min(65dvh,40rem)] md:px-16 md:py-16 lg:px-24">
              <div className="flex flex-1 flex-col justify-end md:justify-center">
                <div className="flex md:max-w-xl flex-col items-start">
                  <h1 className="font-fira-condensed text-[36px] font-medium leading-tight tracking-tight text-white md:text-[56px] md:font-semibold">
                    Is your team AI ready?
                  </h1>

                  <p className="mt-3 font-fira text-sm font-normal leading-relaxed text-[#FFFFFF85] md:mt-4 md:text-base">
                    For teams ready to bring AI into real workflows across the
                    business.
                  </p>

                  <div className="mt-6 flex w-full flex-col items-stretch gap-3 md:mt-8 md:flex-row md:items-center">
                    <button
                      type="button"
                      onClick={scrollToResourceCta}
                      className="w-full rounded-lg border border-[#FFFFFF4D] bg-white px-5 py-2.5 font-fira text-sm font-semibold text-black transition-opacity hover:opacity-90 md:w-auto md:px-6 md:text-[0.9375rem]"
                    >
                      Get Started
                    </button>
                  </div>
                </div>
              </div>

              {/* Logo strip - desktop only */}
              <div className="mt-10 hidden w-full md:block lg:mt-12">
                <p className="mb-3 font-fira text-xs font-normal tracking-[0.18em] text-[#FFFFFF99] sm:text-sm">
                  Sessions run at
                </p>
                <div
                  className="flex flex-wrap items-center gap-x-10 gap-y-4 md:gap-x-6"
                  role="group"
                  aria-label="Companies and teams"
                >
                  {LOGO_FILES.map((file) => (
                    <img
                      key={file}
                      src={logoSrc(file)}
                      alt=""
                      className="h-8 w-auto object-contain md:h-10"
                      loading="lazy"
                      decoding="async"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
